import FetchUtils from 'src/utils/fetch_utils';

/**
 * Reload popup content from view URL and re-init view popup in the new content.
 * callbacks: { toggleTopMode(popup, mode), init(containerSelector) }
 */
export function reloadCurrentPopup(popup, callbacks = {}) {
  const url = popup?.dataset?.viewUrl;
  if (!url) {
    callbacks.toggleTopMode?.(popup, 'readonly');
    return;
  }

  fetch(url, {
    headers: {
      async: true
    }
  }).then(FetchUtils.checkResponseStatus)
    .then((resp) => resp.text())
    .then((html) => {
      const modalContent = popup.closest('.js-modal-content');
      if (!modalContent) {
        return;
      }

      modalContent.innerHTML = html;
      callbacks.init?.('.js-sm-modal');
    })
    .catch((err) => {
      FetchUtils.handleResponseError(err);
      callbacks.toggleTopMode?.(popup, 'readonly');
    });
}
